import { MediaLabel } from '../../../../classes/learnware/LearnwareEnums';
import { runtime } from '../../../../classes/runtime/Runtime';
export class ChoiceOptionAudio {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get option() {
        return this.parent;
    }
    get isHoverAudioPlaying() {
        if (!runtime.availablePackages.Defer)
            return false;
        return !!this.option.context.app.media.mediaPlayer.playerIntents.playingIntents.find(intent => intent.medFile.mediumLabel === MediaLabel.optionHover &&
            this.option.actorMedia.allSoundsFiles.includes(intent.medFile));
    }
}
